export const meta = {
	title: "All Definitions"
};

# Index

<DocGrid>

	<DocAlign align="center">

		<Definition term="javascript" />

	</DocAlign>

</DocGrid>